import { postFilters } from '../../../api/catalog'
import debounce from 'debounce'
import { startLoader, stopLoader } from '../../../filter-common/filterLoaders'
import FilterResults from '../FilterResults'
import prepareFilterData from '../../../filter-common/prepareFilterData'
import { deleteUrlParam } from '../../../url-params/url-params'

const submitFilter = debounce((sortingParams) => {
    deleteUrlParam('page')
    startLoader('results-loader')

    const fData = { ...prepareFilterData(), ...sortingParams }

    postFilters(fData)
        .then((data) => {
            stopLoader('results-loader')
            const productsData = data.data.data.products
            const totalCount = data.data.data.total
            const perPage = data.data.data.perPage
            new FilterResults().render(productsData, totalCount, perPage)
        })
        .catch((error) => {
            stopLoader('results-loader')
            console.log(error)
        })
}, 500)

export { submitFilter }
